// extracted by mini-css-extract-plugin
export default {"heading":"Profile_heading__wYVs+","name":"Profile_name__+1g13","email":"Profile_email__sOuq4","editButton":"Profile_editButton__+VcHb"};